import type { CompleteSuccessStory } from '../../types';
import { CheckCircle2 } from 'lucide-react';

interface ImplementationSectionProps {
  story: CompleteSuccessStory;
}

export function ImplementationSection({ story }: ImplementationSectionProps) {
  const phaseColors = [
    'bg-primary',
    'bg-secondary',
    'bg-accent',
    'bg-primary',
    'bg-secondary',
  ];

  return (
    <section className="py-20 lg:py-32 bg-background">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-accent font-mono text-sm uppercase tracking-wider font-semibold">
            Implementation
          </span>
          <h2 className="font-bold text-4xl lg:text-5xl mt-4 mb-6 text-primary">
            Phased Rollout Across 40 Countries
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            A strategic 18-month implementation ensuring minimal disruption and maximum adoption.
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-8 top-0 bottom-0 w-1 bg-gradient-to-b from-primary via-secondary to-accent hidden lg:block"></div>

          <div className="space-y-12">
            {story.implementationPhases.map((phase, index) => (
              <div key={phase.id} className="relative pl-0 lg:pl-24">
                <div
                  className={`absolute left-5 top-8 w-7 h-7 ${phaseColors[index % phaseColors.length]} rounded-full border-4 border-background hidden lg:block`}
                ></div>
                <div className="bg-card rounded-2xl p-8 shadow-lg border border-border hover:shadow-xl transition-shadow">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
                    <h3 className="font-bold text-2xl text-primary">{phase.phaseName}</h3>
                    <span className="text-muted-foreground font-mono text-sm mt-2 md:mt-0">
                      {phase.duration}
                    </span>
                  </div>
                  <div className="space-y-3 text-muted-foreground">
                    {phase.activities.split('\n').map((activity, idx) => (
                      <div key={idx} className="flex items-start gap-3">
                        <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                        <span>{activity}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
